<template>
  <Config />
</template>

<script>
import Config from '@/components/admin/ConfigForm.vue'

export default {
  name: 'AdministrationConfig',
  components: { Config }
}
</script>

<style scoped>

</style>
